import { cdnUrl } from '@config'

const SEO = ({
  defaultSeo,
  title,
  description,
  keywords,
  image,
  locale,
  pathname,
}) => {
  const seo = {
    title: title || defaultSeo?.title,
    url: defaultSeo?.url,
    description: description || defaultSeo?.description,
    image: image || defaultSeo?.image,
  }

  return (
    <>
      <html lang={locale} />
      <title>{seo?.title}</title>
      <meta name="description" content={seo?.description} />
      <meta property="og:site_name" content="Ubisoft" />
      <meta property="og:title" content={seo?.title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${seo?.url}${pathname}`} />
      <meta property="og:description" content={seo?.description} />
      <meta
        property="og:image"
        content={`${cdnUrl}${seo?.image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}`}
      />
      <meta
        property="og:image:alt"
        content={seo?.image?.description || seo?.description}
      />
      <meta
        property="og:image:width"
        content={seo?.image?.localFile?.childImageSharp?.gatsbyImageData?.width}
      />
      <meta
        property="og:image:height"
        content={
          seo?.image?.localFile?.childImageSharp?.gatsbyImageData?.height
        }
      />
      <meta property="og:locale" content={locale} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@assassinscreed" />
      <meta name="twitter:creator" content="@assassinscreed" />
      <meta name="twitter:description" content={seo?.description} />
    </>
  )
}

export default SEO
